import { TKV2_ORDER_PAIRED_COST_SETTINGS_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2OrderPairedCostSettingsAPIError,
  GetTkv2OrderPairedCostSettingsAPIVariables,
  fetchGetTkv2OrderPairedCostSettingsAPI,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_PAIRED_COST_SETTINGS_API.GET;

export const useGetTkv2OrderPairedCostSettingsAPI = (
  variables: GetTkv2OrderPairedCostSettingsAPIVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2OrderPairedCostSettingsAPIError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2OrderPairedCostSettingsAPIError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2OrderPairedCostSettingsAPIError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders/{orderID}/pairedCostSettings',
      operationId: 'getTkv2OrderPairedCostSettingsAPI',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetTkv2OrderPairedCostSettingsAPI({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
